export { AtnGeneralLedgerComponent as Component } from './page.component'
